const ports = {
    '3000': 'operative',
    '8080': 'operative',
    '5420': 'meet.ecid',
    '5430': 'meet.medvar',
    '5440': 'meet.mentor',
};
/**
 * Verifica se o hostname é localhost ou um IP.
 *
 * @param {string} hostname - O hostname a ser verificado.
 * @returns {boolean} - Retorna true se for localhost ou IP, caso contrário false.
 */
function isLocalOrIP(hostname) {
    // Localhost
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1') {
        return true;
    }
    // IPv4
    const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
    if (ipv4Regex.test(hostname)) {
        return true;
    }
    // IPv6
    const ipv6Regex = /^([0-9a-fA-F]{0,4}:){2,7}[0-9a-fA-F]{0,4}$/;
    if (ipv6Regex.test(hostname)) {
        return true;
    }
    return false;
}
/**
 * Verifica se a URL atual corresponde ao host especificado.
 *
 * @param {Hosts} name - Nome do host a ser verificado.
 * @returns {boolean} - Retorna true se a URL corresponder ao host, caso contrário false.
 */
export function checkUrl(name) {
    const { href, port, hostname } = window.location;
    // Se for localhost ou IP, usa a porta para determinar o host
    if (isLocalOrIP(hostname)) {
        const resolved = ports[port] ?? 'operative';
        return resolved === name;
    }
    // Caso contrário, verifica pela URL
    return href.includes(name);
}
/**
 * Retorna o ambiente atual baseado na URL ou porta.
 *
 * @returns {Hosts} - O ambiente atual.
 */
export function getEnvironment() {
    const { href, port, hostname } = window.location;
    // Se for localhost ou IP, usa a porta para determinar o host
    if (isLocalOrIP(hostname)) {
        return ports[port] ?? 'operative';
    }
    // Verifica pela URL
    if (href.includes('meet.ecid')) {
        return 'meet.ecid';
    }
    if (href.includes('meet.medvar')) {
        return 'meet.medvar';
    }
    if (href.includes('meet.mentor')) {
        return 'meet.mentor';
    }
    return 'operative';
}
